var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("node-view-wrapper", { staticClass: "code-block" }, [
    _c("pre", [_c("code", [_c("node-view-content")], 1)]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }